import { render, staticRenderFns } from "./representante.vue?vue&type=template&id=72b1ce5e&"
import script from "./representante.vue?vue&type=script&lang=js&"
export * from "./representante.vue?vue&type=script&lang=js&"
import style0 from "./representante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports